/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Button from '@material-ui/core/Button';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';
import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';

import styles from '../../../../ActionDrawer.module.scss';

@translate()
@inject('actionDrawerStore', 'projectDetailsStore')
@observer
export default class AssignCostCenterSuccess extends React.Component<*> {
  componentDidMount() {
    const actionDrawerStore: TypeActionDrawerStore = this.props.actionDrawerStore;
    const costCenters: Object = actionDrawerStore.response.project.cost_centres;
    const projectDetails: Object = this.props.projectDetailsStore.details;
    projectDetails.cost_centres = costCenters; // eslint-disable-line camelcase
  }

  renderItems = () => {
    const { t }: TranslatorProps = this.props;
    const actionDrawerStore: TypeActionDrawerStore = this.props.actionDrawerStore;
    const costCenters: Object = actionDrawerStore.response.cost_centres;
    return costCenters.map((costCenter: Object) => (
      <ul key={costCenter.id}>
        <li>
          <b>{t('general:cost_center')}</b>:
        </li>
        <li>{`${costCenter.code} - ${costCenter.name}`}</li>
      </ul>
    ));
  };

  render(): React.Node {
    const { t }: TranslatorProps = this.props;
    const actionDrawerStore: TypeActionDrawerStore = this.props.actionDrawerStore;
    const project: Object = actionDrawerStore.response.project;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={false}
            gutters={true}
            heading={t('general:cost_centers.assigned')}
          >
            <p>
              {t('general:cost_centers.messages.assigned', {
                title: `${project.code} - ${project.name}`,
              })}
            </p>
            <React.Fragment>{this.renderItems()}</React.Fragment>
          </ActionDrawerBlock>
        </div>
        <div className={styles['action-drawer-actions']}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => actionDrawerStore.closeActionDrawer()}
          >
            {t('general:actions.close')}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}
